export default "__VITE_ASSET__$g5CSxqj__"